import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Observable, throwError } from 'rxjs';
import { APIRes } from '../Modules/idms/models/commonAPI.model';
import { catchError } from 'rxjs/operators';
import { BatchCalculationStatus, Queueditemerrors } from '../Modules/settings/models/idms/batch-calculation.model';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class UploadApiService {
    headers: HttpHeaders;

    private uploadApi = environment.uploadAPi;
    private subVal = '';
    // private subVal = environment.subValue;
    private logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;

    constructor(
        private http: HttpClient,
        private authService: MsalService,
        private EnvironmentService: EnvironmentService,
        private appInsights: ApplicationInsights
    ) {
        var _config = EnvironmentService.getConfig();
        this.subVal = _config.subValue;
    }

    addPostAndPutHeaders() {
        this.headers = new HttpHeaders();
        this.headers = this.headers.append('Ocp-Apim-Subscription-Key', this.subVal);
        this.headers = this.headers.append('Accept', 'application/json;');
        this.headers = this.headers.append('Access-Control-Allow-Origin', '*/*');
        this.headers = this.headers.append('content-type', 'application/json');
        this.headers = this.headers.append('InstanceId', `${localStorage.getItem('currentInstanceId')}`);
        this.headers = this.headers.append('Authorization', `Bearer ${localStorage.getItem('msal.accessToken')}`);
    }

    private createHttpParams(params: {}): HttpParams {
        let httpParams: HttpParams = new HttpParams();
        Object.keys(params).forEach((param) => {
            if (params[param]) {
                httpParams = httpParams.set(param, params[param]);
            }
        });
        return httpParams;
    }

    reCalculatePipeCodes(type, payload): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.uploadApi}recalculate/${type}`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getBatches(payload: { start: number; end: number }, Completed: boolean = false, skipErrorlog?: boolean): Observable<APIRes<BatchCalculationStatus>> {
        this.addPostAndPutHeaders();
        if (skipErrorlog) {
            this.headers = this.headers.append('Skip-Error-Dialog', `true`);
        }
        return this.http
            .post(`${this.uploadApi}batch/getbatches/${Completed}`, payload, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getqueueditemerrors(batchId: string, payload: { start: number; end: number }): Observable<APIRes<Queueditemerrors>> {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.uploadApi}batch/getqueueditemerrors/${batchId}`, payload, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }
    //***************API Call to download Excel Template for Data Upload************************** */
    downloadTemplate(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.uploadApi}generate`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
    //***************API Call to get menu list for data import************************** */
    getdownloadmenu(): Observable<APIRes<any[]>> {
        const url = `${this.uploadApi}generate/getdownloadmenu`; //`
        this.addPostAndPutHeaders();

        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
    //***************API Call to download Excel Template for Data Upload************************** */
    uploadFile(params: any): Observable<APIRes<any>> {
        let headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            InstanceId: `${localStorage.getItem('currentInstanceId')}`,
        });
        return this.http.post(`${this.uploadApi}upload`, params, { headers: headers }).pipe(catchError(this.handleError.bind(this)));
    }
    private handleError(error: any) {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        let currOrg = localStorage.getItem('selectedOrgId');
        let currInstance = localStorage.getItem('currentInstanceId');
        if (error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.message);

            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            // this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.message}`);
            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            //  this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        }
        // Return an observable with a user-facing error message.
        return throwError('Something bad happened; please try again later.');
    }
}
